<div *ngIf="visible" class="bg-white rounded-2xl border p-24 my-16 flex flex-col md:flex-row gap-16 items-center justify-between"
  [ngClass]="expired ? 'border-[#FD565B]' : 'border-eggplant-100/[0.1]'">
  <div class="font-sans text-eggplant-100 text-l" [innerHTML]="text"></div>
  <fun-new-button [size]="'xl'" [buttonType]="'colorFull'" (eventClick)="renew()"
    [title]="btnTitle"></fun-new-button>
</div>
